import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "..";
import { IUserLoginResponse } from "../../Services/AuthService";
import { UserLogInResponse } from "../../Generated/orval_api/capsitechAccounts.schemas";

const initialState = {
  isAuthentication:false,
  company: null,
  email: "",
  id: "",
  name: "",
  role: "",
  roles: [],
  token: "",
  tokenExpiry: 0,
  userName: "",
};

const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    setUserData: (state: any, action: PayloadAction<UserLogInResponse>) => {
      state.userName = action.payload.userName;
      state.isAuthentication = true;
      state.email = action.payload.email;
      state.name = action.payload.name;
      state.tokenExpiry = action.payload.tokenExpiry;
      state.id = action.payload.id;
      state.roles = action.payload.roles;
      state.role = action.payload.role;
      state.company = action.payload.company;
      state.token = action.payload.token;
    },

    resetUserData: (state) => {
      state = initialState;
    },
  },
});

export const { setUserData, resetUserData} = userSlice.actions;

export const userData = (state : RootState) => state.user;
export const selectUserId = (state: RootState) => state?.user?.id;

export const isAuthenticated = (state: RootState) => {
  return Boolean(state?.user?.token && state?.user?.id);
};


export default userSlice.reducer;

